// App Payments Functionality (PAYSTACK & RAVE)

import A from './analytics';
import { callApi } from './utils';

export const initPayment = (processor = '', paymentData = {}, type = 'redirect') => {
  // This is the primary entry point for all payment functions.
  // UI components need not bother about payment logic
  // They only send the payment processor and paymentData object
  // This function determines where to pass the payments through
  if (processor === 'RAVE') {
    if (type === 'inline') return openRaveModal(paymentData);
    return redirectToRave(paymentData);
  } else {
    if (type === 'inline') return openPaystackModal(paymentData);
    return redirectToPaystack(paymentData);
  }
};

export const initializePayment = (orderReference, paymentMethod) => {

}

const getCallbackUrl = () => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}/order/confirm`;
};

export const isPaystackOpen = () => Boolean(window.paystackInstance);
export const isRaveOpen = () => Boolean(window.raveInstance);

export const isPaymentOpen = () => isPaystackOpen() || isRaveOpen();

export const closePaymentWindow = (reset = true) => {
  try {
    if (isPaystackOpen()) {
      window.paystackInstance.closeNewCheckout();
      reset && (window.paystackInstance = null);
      // Log paystck modal close action
      A.logAction('PAYSTACK_CLOSE_MODAL', 'PAYSTACK');
    }
    if (isRaveOpen()) {
      window.raveInstance.close();
      reset && (window.raveInstance = null);
      A.logAction('RAVE_CLOSE_MODAL', 'RAVE');
    }
  } catch (e) { }
};

// PAYSTACK

const redirectToPaystack = ({
  amount,
  email,
  ref,
  disco,
  channels,
  callback_url = getCallbackUrl(),
  onError,
  onRedirect,
}) => {
  A.logAction('PAYSTACK_REDIRECT', 'PAYSTACK');

  callApi(
    '/createpaystack',
    {
      reference: ref,
      amount: Number(amount) * 100,
      discoCode: disco,
      email,
      callback_url,
      channels,
    },
    'post'
  )
    .then(res => {
      onRedirect(res);
      // Link received from server. Redirect user to that link
      window.location = res.link;
    })
    .catch(err => {
      onError(err);
      // Redirect links may still be passed in error object
      if (err.link && typeof err.link === 'string') window.location = err.link;
    });
};

//control variable for timeline monitor
export let timelineMonitorControl;

// Monitor transaction timeline every 90 seconds
const timelineMonitor = reference =>
(timelineMonitorControl = setInterval(() => {
  callApi('/payment/resolution', { id: reference })
    .then(data => {
      if (data.code === 20) {
        //Alert user to try transaction again
        alert('Please attempt this transaction again');

        return clearInterval(timelineMonitorControl);
      }

      if (data.code === 40) clearInterval(timelineMonitorControl);
    })
    .catch(err => clearInterval(timelineMonitorControl));
}, 30000));

const openPaystackModal = ({
  amount,
  user,
  ref,
  key,
  disco,
  extraMeta = {},
  channels = ['card', 'bank', 'ussd'],
  onClose = () => { },
  onError = () => { },
  onRedirect = () => { },
  callback = () => { },
}) => {
  const email = String(user.email || user.phone + '@buypower.ng').trim();
  const popError = 'popError';

  try {
    // Create Metadata object to send to paystack
    const metadata = {
      custom_fields: [
        {
          display_name: 'Mobile Number',
          variable_name: 'mobile_number',
          value: user.phone,
        },
        {
          display_name: 'Customer Name',
          variable_name: 'customer_name',
          value: user.name,
        },
        {
          display_name: 'Customer Email',
          variable_name: 'customer_email',
          value: email,
        },
      ],
      ...extraMeta, // Allow extra metadata to be passed to function from caller
    };

    if (window.PaystackPop) {
      A.logAction('PAYSTACK_OPEN_MODAL', 'PAYSTACK');

      let paystackInstance = window.PaystackPop.setup({
        amount: Number(amount) * 100,
        key,
        ref,
        email,
        channels,
        metadata,
        callback,
        onClose: () => {
          onClose();
          clearInterval(timelineMonitorControl);
          A.logAction('PAYSTACK_CLOSE_MODAL', 'PAYSTACK');
        },
      });

      paystackInstance.openIframe();
      window.paystackInstance = paystackInstance;

      //Start process to start monitoring transaction timeline
      timelineMonitor(ref);
    } else {
      throw new Error(popError);
    }
  } catch (err) {
    if (err.message === popError) {
      A.logAction('Redirecting to Paystack...', 'PAYSTACK');
    } else {
      A.logError('PAYSTACK - ' + err.message);
    }
    redirectToPaystack({
      amount,
      email,
      ref,
      disco,
      channels,
      onError,
      onRedirect,
    });
  }
};

// RAVE
const redirectToRave = ({
  amount,
  email,
  ref,
  disco,
  // channels,
  onError,
  onRedirect,
  redirect_url = getCallbackUrl(),
}) => {
  A.logAction('RAVE_REDIRECT', 'RAVE');

  callApi(
    '/createrave',
    {
      reference: ref,
      amount,
      discoCode: disco,
      email,
      redirect_url,
    },
    'post'
  )
    .then(res => {
      onRedirect(res);
      // Link received from server. Redirect user to that link
      window.location = res.link;
    })
    .catch(err => {
      onError(err);
      // Redirect links may still be passed in error object
      if (err.link && typeof err.link === 'string') window.location = err.link;
      // TODO: Error fallback not implemented for Rave
      // Redirect to paystack
      return redirectToPaystack({
        amount,
        email,
        ref,
        disco,
        onError,
        onRedirect,
      });
    });
};

const openRaveModal = ({
  amount,
  user,
  ref,
  key,
  disco,
  // extraMeta = {},
  channels = 'card,account,ussd',
  onClose = () => { },
  onError = () => { },
  onRedirect = () => { },
  callback = () => { },
}) => {
  const email = String(user.email || (user.phone ? user.phone + '@buypower.ng' : '')).trim();
  const phone = user.phone || '';
  const firstName = user.name.split(' ')[0] || 'No Name';
  const lastName = user.name.split(' ')[1] || '';

  const raveInlineError = 'raveInlineError';

  try {
    if (window.getpaidSetup) {
      A.logAction('OPEN_RAVE_MODAL', 'RAVE');

      let raveInstance = window.getpaidSetup({
        PBFPubKey: key,
        customer_email: email,
        customer_phone: phone,
        customer_firstname: firstName,
        customer_lastname: lastName,
        custom_description: 'Pay Electricity Bills Conveniently',
        amount: Number(amount),
        currency: 'NGN',
        payment_options: channels,
        txref: ref,
        onclose: () => {
          onClose();
          A.logAction('RAVE_CLOSE_MODAL', 'RAVE');
        },
        callback: response => {
          /*eslint eqeqeq: 0*/
          if (response.tx.chargeResponseCode == '00' || response.tx.chargeResponseCode == '0') {
            callback(response);
          } else {
            onError(response.tx.message);
          }
        },
      });

      window.raveInstance = raveInstance;
    } else {
      throw new Error(raveInlineError);
    }
  } catch (err) {
    if (err.message === raveInlineError) {
      A.logAction('Redirecting to Rave Standard...', 'RAVE');
    } else {
      A.logError('RAVE - ' + err.message);
    }
    return redirectToRave({
      amount,
      email,
      ref,
      disco,
      channels,
      onError,
      onRedirect,
    });
  }
};



// WEBPACK FOOTER //
// ./src/payments.js